export const SiwzSourceType = {
    REPO: "REPO",
    SIWZ: "SIWZ"
}
